import Api from '@/providers/Api'
import * as _ from 'lodash'

export default {
    // helper method to populate retrofit manufacturer options for other models
    async loadRetrofitManufacturerOptions (modelField, model) {
        const retrofit_manufacturers = await Api.getItems(null, 'retrofit-manufacturer', {}, {}, ['devices'])

        const filtered_retrofit_manufacturers = _.filter(retrofit_manufacturers, e => {
            return _.some(e.devices, { on_road: model.on_road })
        })

        modelField.options = _.map(filtered_retrofit_manufacturers, manufacturer => {
            return {
                value: manufacturer.id, text: manufacturer.name
            }
        })
    }
}
